export const GROWTH_FUNNEL_STEPS = [
  "pricing_viewed",
  "upgrade_clicked",
  "checkout_started",
  "subscription_started",
] as const;

export type GrowthFunnelStep = (typeof GROWTH_FUNNEL_STEPS)[number];
export type GrowthDevice = "mobile" | "desktop";
export type GrowthPlan = "pro" | "ultra";
export type GrowthTier = "free" | GrowthPlan;

const GROWTH_SESSION_ID_PATTERN = /^[A-Za-z0-9_-]{16,80}$/;

export function sanitizeGrowthSessionId(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const candidate = value.trim();
  return GROWTH_SESSION_ID_PATTERN.test(candidate) ? candidate : null;
}

export function sanitizeGrowthDevice(value: unknown): GrowthDevice | null {
  return value === "mobile" || value === "desktop" ? value : null;
}

export function sanitizeGrowthPlan(value: unknown): GrowthPlan | null {
  return value === "pro" || value === "ultra" ? value : null;
}

export function sanitizeGrowthTier(value: unknown): GrowthTier | null {
  return value === "free" || value === "pro" || value === "ultra"
    ? value
    : null;
}

export function isGrowthFunnelStep(value: unknown): value is GrowthFunnelStep {
  return GROWTH_FUNNEL_STEPS.includes(value as GrowthFunnelStep);
}

export function coarsePricingSource(value: string | null | undefined): string {
  if (!value) return "direct";
  if (value.startsWith("/buy-now") || value.startsWith("/vehicles")) {
    return "catalogue";
  }
  if (value.startsWith("/vehicle") || value.startsWith("/listing")) {
    return "listing";
  }
  if (value.startsWith("/damage-analysis")) return "damage_analysis";
  if (value.startsWith("/subscriptions")) return "alerts";
  if (value.startsWith("/selected-cars")) return "saved_cars";
  if (value.startsWith("/onboarding")) return "onboarding";
  return "other";
}
